import { useQuery } from '@tanstack/react-query';
import { repoMarginCallService } from '@/services/trades/repo-margin-call-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';
import type { RepoMarginCallTrade } from '@/types';

/**
 * GET /repo-margin-calls/{id}/lines/ — the trades frozen into one posted margin call (LR-565).
 *
 * Lazy by design: pass `enabled` from the ledger row's expanded state. The breakdown is one line
 * per repo position in the book, which is why it no longer rides along in the history list.
 * Mirrors `useMtmRunMarks`, the Stock-L/B equivalent.
 */
export const useRepoMarginCallLines = (
  callId: number | null,
  enabled: boolean = true,
) => {
  return useQuery<RepoMarginCallTrade[]>({
    queryKey: tradesKeys.repoMarginCallLines(callId ?? 0),
    queryFn: () => repoMarginCallService.getLines(callId!),
    enabled: enabled && callId != null,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
};
